// extracted by mini-css-extract-plugin
module.exports = {"about-header":"index__about-header__2l0S_","informationTitle":"index__informationTitle__2z7Ic","errorMessage":"index__errorMessage__1iwkN"};